.report-abuse-wrap {
  max-height: 83vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .report-abuse-content {
    overflow-y: auto;
    max-height: 90vh;
    .ugc-radio:last-child .container {
      margin-bottom: 0;
      border-bottom: none;
    }
  }

  .report-abuse-other-reason {
    display: block;
    margin: 6px 0 0 36px;
    @at-root [dir='rtl'] & {
      margin: 6px 36px 0 0;
    }
  }

  .report-abuse-button {
    width: 100%;
    background: var(--gray-white);
  }
}
